function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.42 6.42v1.16l-7.28 7.28a4.776 4.776 0 01-1.56-3.52V6.42c0-2.06 1.4-3.77 3.3-4.26.19-.05.37.11.37.3V4c0 .41.34.75.75.75s.75-.34.75-.75V2.46c0-.19.18-.35.37-.3 1.9.49 3.3 2.2 3.3 4.26z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.78 16.22l-.99.99a7.796 7.796 0 01-2.6-5.81V9.81c0-.38.31-.69.69-.69.39 0 .7.31.7.69v1.59c0 1.92.85 3.65 2.2 4.82zm12.03-6.41v1.59c0 4.07-3.13 7.42-7.11 7.77v2.13c0 .39-.31.7-.7.7-.39 0-.7-.31-.7-.7v-2.13c-1.09-.1-2.12-.42-3.04-.93l1.03-1.03c.82.38 1.74.6 2.71.6 3.54 0 6.42-2.88 6.42-6.41V9.81c0-.38.31-.69.7-.69.38 0 .69.31.69.69z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.42 10.08v1.45c0 2.58-2.22 4.65-4.86 4.4-.28-.03-.56-.08-.82-.17l5.68-5.68z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.77 2.23c-.3-.3-.79-.3-1.09 0L2.23 20.69c-.3.3-.3.79 0 1.09a.758.758 0 001.08-.01L21.77 3.31c.31-.3.31-.78 0-1.08z"
})));